'use client'

import {ModalWindow} from "@/app/[locale]/common/components/ModalWindow/ModalWindow";
import {useEffect, useState} from "react";
import Image from "next/image";
import AdsImage from '../../assets/images/monitoring-platform/ads_photo.webp';
import s from './Ads.module.scss';
import {APP_ROUTES} from "@/app/[locale]/common/constants/app";
import Link from "next/link";

export const Ads = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(true);
    }, []);

    const closeAds = () => setIsOpen(false);

    return (
        <ModalWindow isOpen={isOpen} closeModalWindow={closeAds}>
            <div className={s.ads}>
                <div className={s.ads_imageContainer}>
                    <Link href={`en${APP_ROUTES.PLATFORM}`}>
                        <Image src={AdsImage} alt={'ads-image'} />
                    </Link>
                </div>
                <label className={s.ads_label}>
                    We Are Expanding Our Horizons: Launching the Development of Our Own Monitoring Platform
                </label>
                <p>
                    The company is taking an important step forward — we are now engaged not only in installing GPS trackers, fuel level sensors, flow meters, and other telematics systems. We have made a strategic decision to create our own monitoring platform, which will become a logical continuation of our experience and expertise accumulated over years of working with equipment and client projects.
                </p>
                <Link className={s.ads_link} href={`en${APP_ROUTES.PLATFORM}`}>
                    Follow the link to learn more.
                </Link>
            </div>
        </ModalWindow>
    );
};